import React from "react"

// 防骚扰黑名单
export { default as PhoneAPCallDetail } from './CallDetail'
export { default as PhoneAPCheckOnline } from './CheckOnline'

export default ({children}: any) => (<>{children}</>)
